/** @file Writes one per-slot run row [slot, indexStart, indexCount] with change tracking. */
import { invariant } from '@pose2d/std/invariant';
import { RENDER_LAYOUT, type RenderBuffers } from '../renderBuffers';
import type { BuildState } from './buildState';

const RS = RENDER_LAYOUT.RUN_STRIDE;

/** Writes run row `st.r` (compare-on-write; `changed` + `topo` on change) and advances `st.r`. */
export function writeRun(out: RenderBuffers, st: BuildState, slot: number, indexStart: number, indexCount: number): void {
  invariant((st.r + 1) * RS <= out.runs.length, 'buildRender: run capacity exceeded (size with createRenderBuffers or pass extraDraws)');
  const runs = out.runs, o = st.r * RS;
  if (runs[o] !== slot || runs[o + 1] !== indexStart || runs[o + 2] !== indexCount) {
    runs[o] = slot;
    runs[o + 1] = indexStart;
    runs[o + 2] = indexCount;
    st.changed = true;
    st.topo = true;
  }
  st.r += 1;
}
